import { Component, ChangeDetectionStrategy, HostBinding, OnInit, inject } from '@angular/core';
import { isTestingBrowser } from '@skyeng/libs/shared/device';
import { SkyproPublicFeatureFlags } from './feature-flags';
import { FeatureFlagsService } from '@skyeng/libs/skypro/shared';
import { Title } from '@angular/platform-browser';
import { SkyproFaviconService } from '@skyeng/libs/skypro/misc';
import { SkyproConfig } from '@skyeng/libs/skypro/base-config/const';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
  `,
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private featureFlagsService = inject(FeatureFlagsService);
  private titleService = inject(Title);
  private skyproFaviconService = inject(SkyproFaviconService);
  private config = inject(SkyproConfig);

  @HostBinding('@.disabled') disableAnimations = false;

  constructor() {
    const config = this.config;

    const featureFlags = Object.keys(SkyproPublicFeatureFlags);
    const appUrl = this.config.appUrl;

    this.featureFlagsService.init(featureFlags);
    this.titleService.setTitle(config.title);
    this.skyproFaviconService.setIcons('skypro', appUrl);
  }

  ngOnInit(): void {
    this.disableAnimations = isTestingBrowser();
  }
}
